import React from 'react';
import ReactLoading from 'react-loading';
import styled from 'styled-components/macro';

const LoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
> div {
  display: flex;
  justify-content: center;
}
`;

interface IProps {
  color: string;
  width?: number;
  height?: number;
}
const ResultLoading: React.FC<IProps> = ({ color, width, height }) => {
  return (
    <LoadingWrapper>
      <ReactLoading type="spin" color={color} width={width ? width : 100} height={height ? height : 250} />
    </LoadingWrapper>
  );
};

export default ResultLoading;
